import {
  addNavMenuItem,
  addNavMenuSection,
  addActionBarItem,
  PageLocationId,
  registerPageTab,
} from "@bb-vendure/admin-ui/core";
import { map } from "rxjs";
import { reviewPackagesProduct } from "./components/package-review/review-packages-product";
import { reviewPackagesOrder } from "./components/package-review/review-packages-order";
import { PackageReviewListComponent } from "./components/package-review/List/package-review-list.component";
import { PackageReviewSummaryListComponent } from "./components/package-review/summary-table/package-review-summary-table.component";
import { PackageSummaryComponent } from "./components/package-summary/package-summary.component";

export default [
  // addNavMenuItem(
  //   "package-review"
  // ),

  addActionBarItem({
    id: "review-packages-product",
    locationId: "product-detail",
    label: "common.review-packages",
    icon: "bundle",
    buttonColor: "primary",
    onClick: (event, context) => {
      //Disable the button for 5 seconds
      //@ts-ignore
      event.target.disabled = true;
      setTimeout(() => {
        //@ts-ignore
        event.target.disabled = false;
      }, 5000);
      reviewPackagesProduct(context);
    },
    requiresPermission: "CreatePackageReview",
    buttonState: (context) => {
      return context.entity$.pipe(
        map((res) => {
          if (!res) {
            return {
              disabled: false,
              visible: false,
            };
          }

          return {
            disabled: false,
            visible: true,
          };
        })
      );
    },
  }),
  addActionBarItem({
    id: "review-packages-order",
    locationId: 'order-detail',
    label: "common.review-packages",
    icon: "bundle",
    buttonColor: "primary",
    onClick: (event, context) => {
      //Disable the button for 5 seconds
      //@ts-ignore
      event.target.disabled = true;
      setTimeout(() => {
        //@ts-ignore
        event.target.disabled = false;
      }, 5000);
      reviewPackagesOrder(context);
    },
    requiresPermission: "CreatePackageReview",
    buttonState: (context) => {
      
      return context.entity$.pipe(
        map((res) => {
          if (!res) {
            return {
              disabled: false,
              visible: false,
            };
          }

          return {
            disabled: false,
            visible: true,
          };
        })
      );
    },
  }),

  registerPageTab({
    location: "package-review-list" as PageLocationId,
    tab: "nav.package-review",
    route: "/extensions/package-reviews",
    //tabIcon: "star",
    component: PackageReviewListComponent,
  }),

  registerPageTab({
    location: "package-review-list" as PageLocationId,
    tab: "nav.package-review-summary",
    route: "/extensions/package-reviews/summary",
    //tabIcon: "star",
    component: PackageReviewSummaryListComponent,
  }),

  registerPageTab({
    location: "package-review-list" as PageLocationId,
    tab: "package.package-summary",
    route: "/extensions/package-reviews/package-summary",
    //tabIcon: "bundle",
    component: PackageSummaryComponent,
  }),
];
